var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCard = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21 7H3v-.5C3 5.673 3.673 5 4.5 5h15c.827 0 1.5.673 1.5 1.5zM3 10h18V8H3zm18 7.5c0 .827-.673 1.5-1.5 1.5h-15c-.827 0-1.5-.673-1.5-1.5V11h18zM19.5 4h-15A2.5 2.5 0 0 0 2 6.5v11C2 18.879 3.121 20 4.5 20h15c1.379 0 2.5-1.121 2.5-2.5v-11C22 5.121 20.879 4 19.5 4M15 14a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-3 3c.6 0 1.133-.271 1.5-.691.367.42.9.691 1.5.691 1.103 0 2-.897 2-2s-.897-2-2-2c-.6 0-1.133.271-1.5.691-.367-.42-.9-.691-1.5-.691-1.103 0-2 .897-2 2s.897 2 2 2",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export default ForwardRef;